import { atom } from 'nanostores';

export type DashboardList = { id: number; name: string }[];

export const dashboardListOpen = atom(false);
export const dashboardList = atom<DashboardList>([]);
